export default __webpack_public_path__ + "static/media/kitchen4-afterE-2048w.77dcae0d.avif";